export const siteUserIds = (site) => {
  let users = Array.isArray(site?.users) ? site.users : [];
  if (!users.length && typeof site?.users === "string") {
    try {
      const parsed = JSON.parse(site.users);
      users = Array.isArray(parsed) ? parsed : [];
    } catch {
      users = [];
    }
  }
  const legacyUser = site?.user ? [site.user] : [];

  return [...users, ...legacyUser]
    .map((id) => String(id))
    .filter((id) => id && id !== "0");
};

export const siteAssignedToUser = (site, userId) =>
  siteUserIds(site).includes(String(userId));
